import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { SoapRequest, SoapResponseItem } from "@/types/soap";

async function create(data: SoapRequest) {
  const response = await http.postData("/soap-dokter", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function update(id, data: SoapRequest) {
  const response = await http.putData(`/soap-dokter/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function getByRegister(
  register_id: string | number
): Promise<{ status: number; data: SoapResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/soap-dokter`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http.getData(`/soap-dokter/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function destroy(id, alasan) {
  const response = await http.deleteDataParam(`/soap-dokter/${id}`, {
    params: {
      alasan: alasan
    }
  }).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy
};
